import React from "react";
import { Link } from "react-router-dom";

export function Logo({ className = "", onClick }) {
  return (
    <Link to="/" onClick={onClick} className={`flex items-center gap-2.5 group ${className}`} data-testid="logo-link">
      <span className="relative flex h-9 w-9 items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-gradient-to-br from-teal-400/30 to-amber-500/20 blur-[6px] transition-all group-hover:from-teal-400/50" />
        <svg viewBox="0 0 32 32" className="relative h-8 w-8" fill="none">
          <circle cx="16" cy="16" r="13" stroke="#14B8A6" strokeWidth="1.5" />
          <circle cx="16" cy="16" r="7" stroke="#5EEAD4" strokeWidth="1" opacity="0.7" />
          <circle cx="16" cy="16" r="2.4" fill="#F59E0B" />
        </svg>
      </span>
      <span className="font-heading text-lg font-semibold tracking-tight text-slate-50">
        The<span className="text-teal-400">Inner</span><span className="text-slate-500 text-sm">.app</span>
      </span>
    </Link>
  );
}
